"use strict";

exports.__esModule = true;
exports.getConsentCookie = void 0;
var getConsentCookie = exports.getConsentCookie = function getConsentCookie() {
  if (typeof document === 'undefined') return null;
  var cookies = document.cookie.split('; ');
  var consentCookie = cookies.find(function (cookie) {
    return cookie.startsWith('cookie-consent');
  });
  var encodedConsentCookie = consentCookie === null || consentCookie === void 0 ? void 0 : consentCookie.slice(consentCookie.lastIndexOf('=') + 1, consentCookie.length);
  if (!encodedConsentCookie) return null;
  var decodedConsentCookieInfo = Object(decodeURIComponent(encodedConsentCookie));
  return decodedConsentCookieInfo;
};